import { Pipe, PipeTransform } from '@angular/core';
import { NotificationType } from '@platform-frontend/util';

@Pipe({
  name: 'asBootstrapClass'
})
export class AsBootstrapClassPipe implements PipeTransform {
  transform(notificationType: NotificationType): string {
    switch (notificationType) {
      case 'success':
        return 'alert-success';
      case 'info':
      case 'refresh':
        return 'alert-info';
      case 'warning':
        return 'alert-warning';
      case 'error':
        return 'alert-danger';
      default:
        throw new Error(`Unknown notification type ${notificationType}.`);
    }
  }
}
